import { z } from "zod"

/** Validated `/admin` search params. */
export const adminAccountsSearchSchema = z.object({
  q: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.string().min(1).max(200).optional(),
  ),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  offset: z.coerce.number().int().min(0).default(0),
  sort: z.string().default("created_at.desc"),
  // FLO-185 staff filter — "pending" is deletion_requested_at set (any state), "scheduled" /
  // "hold" narrow to whether purge_scheduled_at is set.
  deletion: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.enum(["pending", "scheduled", "hold"]).optional(),
  ),
})

export type AdminAccountsSearch = z.infer<typeof adminAccountsSearchSchema>

export const defaultAdminAccountsSearch: AdminAccountsSearch = adminAccountsSearchSchema.parse({})

/** Validated `/admin/deletions` search params (FLO-203). */
export const adminDeletionsSearchSchema = z.object({
  q: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.string().min(1).max(200).optional(),
  ),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  offset: z.coerce.number().int().min(0).default(0),
  sort: z.string().default("requested_at.desc"),
  state: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.enum(["pending", "cancelled", "purging", "complete"]).optional(),
  ),
})

export type AdminDeletionsSearch = z.infer<typeof adminDeletionsSearchSchema>

export const defaultAdminDeletionsSearch: AdminDeletionsSearch = adminDeletionsSearchSchema.parse({})
